import React from "react";
import PropTypes from "prop-types";

const TBody = ({
    children,
    className,
    testSection,
    ...props
}) => {
    return <tbody data-test-section={testSection} className={className} {...props}>{children}</tbody>;
};

TBody.propTypes = {
    /** Should be a `Table.TR` component */
    children: PropTypes.node,
    /** CSS class names. */
    className: PropTypes.string,
    /** Hook for automated JavaScript tests */
    testSection: PropTypes.string,
};

TBody.displayName = "Table.TBody";

export default TBody;
